export enum Languages {
    English = 'EN',
    Bulgarian = 'BG'
}
